var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmile = function SvgSmile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 29.9993C25.5223 29.9993 29.9993 25.5223 29.9993 19.9997C29.9993 14.477 25.5223 10 19.9997 10C14.477 10 10 14.477 10 19.9997C10 25.5223 14.477 29.9993 19.9997 29.9993Z",
    stroke: "#5A6367",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.998C17.85 24.6281 18.8851 24.9981 20.0001 24.9981C21.1151 24.9981 22.1502 24.6281 23.0002 23.998",
    stroke: "#5A6367",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 18.5C24.002 19.3281 23.554 20.0001 23.002 20.0001C22.45 20.0001 22.002 19.3281 22.002 18.5C22.002 17.672 22.45 17 23.002 17C23.554 17 24.002 17.672 24.002 18.5Z",
    fill: "#5A6367"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.0001C17.5523 20.0001 18.0001 19.3285 18.0001 18.5C18.0001 17.6716 17.5523 17 17 17C16.4477 17 16 17.6716 16 18.5C16 19.3285 16.4477 20.0001 17 20.0001Z",
    fill: "#5A6367"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "smile.ea56b05604dc546d88c4553dc8cfb214.svg";